/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { OrganizationsControllerGetProjectQuotaQueryResponse, OrganizationsControllerGetProjectQuotaPathParams, OrganizationsControllerGetProjectQuota400, OrganizationsControllerGetProjectQuota401, OrganizationsControllerGetProjectQuota403, OrganizationsControllerGetProjectQuota404 } from "../../models/organizationsController/OrganizationsControllerGetProjectQuota";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { organizationsControllerGetProjectQuota } from "../../clients/organizationsService/organizationsControllerGetProjectQuota";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const organizationsControllerGetProjectQuotaQueryKey = (id: OrganizationsControllerGetProjectQuotaPathParams["id"]) => [{
  url: '/api/v1/organizations/:id/project-quota',
  params: {
    id: id
  }
}] as const;
export type OrganizationsControllerGetProjectQuotaQueryKey = ReturnType<typeof organizationsControllerGetProjectQuotaQueryKey>;
export function organizationsControllerGetProjectQuotaQueryOptions(id: OrganizationsControllerGetProjectQuotaPathParams["id"], config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = organizationsControllerGetProjectQuotaQueryKey(id);
  return queryOptions<OrganizationsControllerGetProjectQuotaQueryResponse, ResponseErrorConfig<OrganizationsControllerGetProjectQuota400 | OrganizationsControllerGetProjectQuota401 | OrganizationsControllerGetProjectQuota403 | OrganizationsControllerGetProjectQuota404>, OrganizationsControllerGetProjectQuotaQueryResponse, typeof queryKey>({
    enabled: !!id,
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return organizationsControllerGetProjectQuota(id, config);
    }
  });
}

/**
 * @summary Get org-wide EMS project usage versus the entitlement cap. Returns null used/total when EMS validation is off for the organization or quota does not apply.
 * {@link /api/v1/organizations/:id/project-quota}
 */
export function useOrganizationsControllerGetProjectQuota<TData = OrganizationsControllerGetProjectQuotaQueryResponse, TQueryData = OrganizationsControllerGetProjectQuotaQueryResponse, TQueryKey extends QueryKey = OrganizationsControllerGetProjectQuotaQueryKey>(id: OrganizationsControllerGetProjectQuotaPathParams["id"], options: {
  query?: Partial<QueryObserverOptions<OrganizationsControllerGetProjectQuotaQueryResponse, ResponseErrorConfig<OrganizationsControllerGetProjectQuota400 | OrganizationsControllerGetProjectQuota401 | OrganizationsControllerGetProjectQuota403 | OrganizationsControllerGetProjectQuota404>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? organizationsControllerGetProjectQuotaQueryKey(id);
  const query = useQuery({
    ...organizationsControllerGetProjectQuotaQueryOptions(id, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<OrganizationsControllerGetProjectQuota400 | OrganizationsControllerGetProjectQuota401 | OrganizationsControllerGetProjectQuota403 | OrganizationsControllerGetProjectQuota404>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}